import { render, staticRenderFns } from "./DialogInvoiceDetails.vue?vue&type=template&id=36f016b2&scoped=true&"
import script from "./DialogInvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./DialogInvoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./DialogInvoiceDetails.vue?vue&type=style&index=0&id=36f016b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f016b2",
  null
  
)

export default component.exports